import {Component, HostBinding, Input} from '@angular/core';
import {DropdownColors} from '../../ui-dropdown.component';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
    selector: 'ui-drop-item',
    templateUrl: './ui-drop-item.component.html',
    styleUrls: ['./ui-drop-item.component.scss'],
    standalone: false,
    hostDirectives: [
        {
            directive: MatTooltip,
            inputs: ['matTooltip: tooltip', 'matTooltipPosition: tooltipPosition']
        }
    ]
})
export class UiDropItemComponent {
    @Input() icon?: string = undefined;
    @Input() disabled = false;
    @Input() highlight = false;
    @Input() active = false;
    @Input() color: keyof typeof DropdownColors | 'warning' = undefined;
    @Input() tooltip: string;
    @Input() tooltipPosition: 'left' | 'right' | 'above' | 'below' | 'before' | 'after' = 'before';

    @HostBinding('class') get className() {
        const classes = [
            this.color ? `${this.color}-item` : '',
            this.disabled ? 'disabled' : '',
            this.highlight && !this.disabled ? 'highlight' : '',
            this.active ? 'active' : ''
        ];
        return classes.filter(Boolean).join(' ');
    }

}
